import {Component} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {Footer} from './components/footer/footer'
import {Header} from './components/header/header'

@Component({
  selector: 'smt-root',
  imports: [RouterOutlet, Footer, Header],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
